import React, {useState, useEffect} from 'react';
import {
   ImageBackground,
   View,
   StyleSheet,
   Image,
   Text,
   TouchableOpacity,
   Dimensions,
   Platform,
   ActivityIndicator,
} from 'react-native';
import Orientation from 'react-native-orientation-locker';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector, useDispatch} from 'react-redux';
import {selectedScratchPadRecord} from '../../redux/slices/ScratchPadRecordSlice';
import {selectAuthData} from '../../redux/slices/AuthSlice';

import {
   FONT_FAMILY_BOLD,
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_MEDIUM,
   UPDATE_TEST_RECORD,
   isNewAPI,
   getFinalTestParams,
   COURSE_ROOT_ITEM,
   isWeb,
   GET_DASHBOARD_DATA,
   WHITE_ICON_HOVER_TINT_COLOR,
   alertHandler,
   isiOS,
   white,
   isMobile,
   isMacOS,
   isWindows,
} from '../../utils/utils';
import {apiPostRequest} from '../../service/network_access';
import logger from '../../utils/logger';
import {removeSaveItem, retrieveAppData} from '../../utils/preference';
import {
   getCourseData,
   getModuleCompetedCount,
   setCourseData,
} from '../../redux/slices/EnrolledCourseDataSlice';
import {setIsDashboardRefreshRequired} from '../../redux/slices/DashboardRefreshSlice';
import {ProgressDialog} from '../../utils/progressDialog';
import {setResponseAlertData} from '../../redux/slices/ResponseAlertSlice';
import {isMacOs} from 'react-device-detect';
import ReviewQuestionScreen from './ReviewQuestionScreen';
let incoreectFinalQuesAnsData = [];
export const ScoreBoard = ({route, navigation}) => {
   const currentSlide = route.params.currentSlide;
   const isLandscapeMode = useSelector(selectScreenOrientation);
   logger('isLandscapeMode', isLandscapeMode);
   const isPreTeastEnable = route.params.isPreTeastEnable;
   const isPassed = route.params.isPassed;
   incoreectFinalQuesAnsData = route.params.incorrectQuestionList;
   const proceedText = isPassed
      ? 'Congratulations you passed.'
      : 'Sorry, you failed.';
   const buttonActionHeaderText = isPassed
      ? 'Press Done to continue'
      : 'Please review module information and repeat the test ';
   const buttonActionText = isPassed ? 'Done' : 'OK';
   const questionAsked = route.params.questionAsked;
   const correctAnswerCount = route.params.correctAnswerCount;
   const finalScore = route.params.finalScore;
   const qData = route.params.qData;
   const moduleIndex = route.params.moduleIndex;
   const passCode = isPreTeastEnable ? 'PT' : 'T';
   const qCorrect = route.params.qCorrect;
   const scratchPadString = useSelector(selectedScratchPadRecord);
   const scratchPad = JSON.parse(scratchPadString);
   //const {width, height} = Dimensions.get('window');
   const [width, setWidth] = useState(Dimensions.get('window').width);
   const [height, setHeight] = useState(Dimensions.get('window').height);
   const percentageRequirement = route.params.percentageRequirement;
   const authData = useSelector(selectAuthData);
   const enrolledCourse = useSelector(getCourseData);
   const CourseSaveCount = enrolledCourse.courseSaveCount;
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const getMCompetedCount = useSelector(getModuleCompetedCount);
   const [isApiLoading, setiSsApiLoading] = useState(true);
   const [updateEnrolledCourseData, setUpdateEnrolledCourseData] = useState();
   const [isFinalTestReviewEnable, setFinalTestReviewEnable] = useState(false);

   const closeFullscreen = () => route.params.closeFullscreen();
   const [isHover, setHover] = useState(false);
   const dispatch = useDispatch();
   useEffect(() => {
      const handleBeforeUnload = event => {
         if (Platform.OS === 'web') {
            event.preventDefault();
            event.returnValue = '';
            //alert('Back navigation is disabled on this page.');
            alertHandler(
               dispatch,
               setResponseAlertData,
               'Back navigation is disabled on this page.',
               'NO_BACK',
            );
            navigation.navigate('ScoreBoard', {
               navigation: navigation,
               isPassed: isPassed,
               questionAsked: questionAsked,
               finalScore: finalScore,
               correctAnswerCount: correctAnswerCount,
               qData: qData,
               moduleIndex: moduleIndex,
               qCorrect: qCorrect,
               percentageRequirement: percentageRequirement,
            });
         }
      };

      // Add the event listener when the component mounts.
      if (Platform.OS === 'web') {
         window.addEventListener('popstate', handleBeforeUnload);
      }
      callSubmitTestAPI();
      const handleResize = () => {
         setWidth(Dimensions.get('window').width);
         setHeight(Dimensions.get('window').height);
      };
      Dimensions.addEventListener('change', handleResize);
      // Remove the event listener when the component unmounts to avoid memory leaks.
      return () => {
         if (Platform.OS === 'web') {
            window.removeEventListener('popstate', handleBeforeUnload);
         }
         Dimensions.removeEventListener('change', handleResize);
      };
   }, []);

   function callSubmitTestAPI() {
      const scratchPadRecord = isNewAPI
         ? scratchPad.ScratchPadRecordsList
         : scratchPad.scratchPadRecord;
      let submitTestParams = getFinalTestParams(
         scratchPadRecord,
         authData,
         moduleIndex,
         questionAsked,
         qCorrect,
         passCode,
         qData,
         CourseSaveCount,
      );
      apiPostRequest({url: UPDATE_TEST_RECORD, parms: submitTestParams})
         .then(res => {
            logger('finalResult::', res);
         })
         .catch(error => {
            logger('error::', error);
         })
         .then(res => {
            const reqParms = {
               theData: JSON.stringify({
                  EmployeeKey: authData.EmployeeKey,
               }),
            };
            apiPostRequest({url: GET_DASHBOARD_DATA, parms: reqParms}).then(
               res => {
                  if (
                     res !== null &&
                     res !== undefined &&
                     typeof res !== 'string'
                  ) {
                     logger('dashBoardData::', res);
                     //Filter the cousers of version 9
                     const filteredCourses =
                        res.UserTrainingEnrolledRecordsList.filter(
                           course => course.courseVersion != '9',
                        ).filter(
                           course =>
                              course.courseNameID ===
                              enrolledCourse.courseNameID,
                        );
                     if (filteredCourses.length == 0 || !isPassed) {
                        setUpdateEnrolledCourseData(enrolledCourse);
                     } else {
                        setUpdateEnrolledCourseData(filteredCourses[0]);
                     }
                     setiSsApiLoading(false);
                  }
               },
            );
         });
   }

   return isFinalTestReviewEnable ? (
      <View
         style={{backgroundColor: '#000000', height: isWeb ? '100vh' : '100%'}}>
         {
            <ReviewQuestionScreen
               finalQuesAnsData={incoreectFinalQuesAnsData}
               isReviewTest={false}
               moduleIndex={moduleIndex}
               currentSlide={currentSlide}
               percentageRequirement={percentageRequirement}
               onNextPress={() => {
                  nextSlide();
               }}
               onBeginTest={() => {
                  //To handle Tutorial view
                  // setFinalTestStarted(true);
               }}
               isFinalTest={true}
               closeFullscreen={closeFullscreen}
               isPreTeastEnable={isPreTeastEnable}
               titleHancler={webTitle => {
                  //setWebTitle(webTitle);
               }}
               isFinalTestReviewEnable={isFinalTestReviewEnable}
               iQData={qData}
               finalReviewSubmited={finalTestReviwSubmitted}
            />
         }
      </View>
   ) : (
      <View
         style={[
            {
               flex: 1,
               backgroundColor: '#000000',

               ...Platform.select({
                  web: {
                     flex: null,
                     minHeight: '100vh',
                  },
               }),
            },
            // isWeb &&
            //    isLandscapeSmallWebView && {
            //       ...Platform.select({
            //          web: {
            //             height: '100vh',
            //             top: 0,
            //             left: '100vh',
            //             transform: 'rotate(90deg)',
            //             transformOrigin: 'left top',
            //             width: '100vw',
            //          },
            //       }),
            //    },
         ]}>
         <ImageBackground
            /* source={
               isPassed
                  ? require('../../assets/score_s_bg.png')
                  : require('../../assets/score_f_bg.png')
            } */
            source={require('../../assets/bg_final_test_new.png')}
            style={[
               styles.backgroundImage,
               {
                  ...Platform.select({
                     web: {
                        minHeight: '100vh',
                     },
                  }),
               },
            ]}>
            {(isMobile || isMacOS || isWindows) && isApiLoading ? (
               <View
                  style={{
                     width: '100%',
                     height: '100%',
                     zIndex: 999,
                     justifyContent: 'center',
                     alignItems: 'center',
                     position: 'absolute',
                  }}>
                  <ActivityIndicator size="large" color={white} />
               </View>
            ) : (
               <ProgressDialog visible={isApiLoading && !isMobile} />
            )}

            <View
               style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  resizeMode: 'contain',
                  alignItems: 'center',
                  opacity: 0.5,
               }}
            />

            <View
               style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                  marginTop: isLandscapeMode ? height * 0.1 : height * 0.06,
                  marginBottom: isLandscapeMode ? height * 0.1 : height * 0.06,
                  ...Platform.select({
                     web: {
                        marginTop: isLandscapeSmallWebView ? 8 : 40,
                        marginBottom: isLandscapeSmallWebView ? 8 : 40,
                     },
                  }),
               }}>
               <View
                  style={{
                     width: isLandscapeMode ? width * 0.7 : width * 0.47,
                     // height: isLandscapeMode ? height * 0.18 : height * 0.1,
                     marginTop: 0,
                     flexDirection: isLandscapeMode ? 'column' : 'row',
                     alignItems: 'center',
                     justifyContent: 'center',
                     ...Platform.select({
                        web: {
                           width: isLandscapeMode
                              ? width * 0.7
                              : isLandscapeSmallWebView
                              ? width * 0.47
                              : width * 0.7,
                        },
                     }),
                  }}>
                  <Image
                     source={
                        isPassed
                           ? require('../../assets/Correct_Icon.png')
                           : require('../../assets/Incorrect_Icon.png')
                     }
                     style={{
                        width: isLandscapeMode ? 96 : 32,
                        height: isLandscapeMode ? 96 : 32,
                        ...Platform.select({
                           android: {
                              width: isLandscapeMode ? 72 : 32,
                              height: isLandscapeMode ? 72 : 32,
                           },
                        }),
                     }}
                  />
                  <Text
                     style={{
                        color: isPassed ? '#26E555' : '#F00',
                        fontSize: isLandscapeMode ? 32 : 20,
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginStart: isLandscapeMode ? 5 : 8,
                        marginTop: isLandscapeMode
                           ? 16
                           : isLandscapeSmallWebView
                           ? 5
                           : isMobile
                           ? 2
                           : 0,
                        alignItems: 'center',
                        fontWeight: '700',
                        ...Platform.select({
                           android: {
                              fontSize: isLandscapeMode ? 28 : 20,
                           },
                        }),
                     }}>
                     {proceedText}
                  </Text>
               </View>
               <View
                  style={{
                     width: isLandscapeMode ? width * 0.54 : width * 0.45,
                     marginTop: isLandscapeMode ? (isWeb ? 5 : 48) : 0,
                     alignItems: 'center',
                     justifyContent: 'center',
                     flexDirection: 'row',
                     ...Platform.select({
                        web: {
                           width: isLandscapeMode
                              ? width * 0.54
                              : isLandscapeSmallWebView
                              ? width * 0.45
                              : width * 0.7,
                        },
                     }),
                  }}>
                  <View
                     style={{
                        // position: 'absolute',
                        width: isLandscapeMode ? width * 0.54 : width * 0.45,
                        // height: isLandscapeMode ? height * 0.06 : height * 0.1,
                        marginTop: isLandscapeMode ? null : 16,
                        alignItems: 'center',
                        paddingVertical: isLandscapeMode
                           ? 16
                           : isLandscapeSmallWebView
                           ? 16
                           : 8,
                        justifyContent: 'center',
                        flexDirection: 'row',
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        // opacity: 0.2,
                        borderRadius: isLandscapeMode ? 16 : 8,
                        ...Platform.select({
                           web: {
                              marginTop: isLandscapeSmallWebView
                                 ? 8
                                 : isLandscapeMode
                                 ? 64
                                 : 0,
                              // marginVertical: 48,
                              // paddingVertical: isLandscapeMode ? 28 : 4,
                              // height: isLandscapeMode ? 64 : 40,
                              width: isLandscapeMode
                                 ? width * 0.54
                                 : isLandscapeSmallWebView
                                 ? '60vw'
                                 : width * 0.7,
                           },
                           android: {
                              marginTop: isLandscapeMode ? -30 : 16,
                           },
                           windows: {
                              marginTop: isLandscapeMode ? -20 : 16,
                           },
                        }),
                     }}>
                     <Image
                        source={require('../../assets/course_hightlight_24.png')}
                        style={{
                           width: isLandscapeMode ? 24 : 15.9,
                           height: isLandscapeMode ? 26 : 19.5,
                           ...Platform.select({}),
                        }}
                     />
                     <Text
                        style={{
                           color: '#FFFFFF',
                           fontSize: isLandscapeMode ? 24 : 20,
                           fontFamily: FONT_FAMILY_BOLD,
                           marginStart: isLandscapeMode ? 16.25 : 11.26,
                           alignItems: 'center',
                           fontWeight: '400',
                           ...Platform.select({
                              web: {},
                              ios: {
                                 fontWeight: '700',
                              },
                           }),
                        }}>
                        Result
                     </Text>
                  </View>
               </View>

               {/** Parent view in column containing result details */}
               <View
                  style={{
                     flexDirection: 'column',
                     alignItems: 'center',
                     // height: isLandscapeMode ? height * 0.33 : height * 0.39,
                     width: isLandscapeMode ? width * 0.54 : width * 0.45,
                     marginTop: isLandscapeMode
                        ? 16
                        : isLandscapeSmallWebView
                        ? 0
                        : 8,
                     justifyContent: 'center',
                     // paddingBottom: '3%',
                     ...Platform.select({
                        web: {
                           // marginTop: '3%',
                        },
                     }),
                  }}>
                  <View
                     style={{
                        // height: isLandscapeMode ? height * 0.25 : height * 0.38,
                        width: isLandscapeMode ? width * 0.54 : width * 0.45,
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        borderRadius: isLandscapeMode ? 16 : 8,
                        // position: 'absolute',
                        // justifyContent: 'center',
                        paddingVertical: isLandscapeMode ? 40 : 16,
                        alignItems: 'center',
                        ...Platform.select({
                           web: {
                              marginTop: isLandscapeSmallWebView
                                 ? 8
                                 : isLandscapeMode
                                 ? 0
                                 : 10,
                              paddingVertical: isLandscapeSmallWebView
                                 ? 12
                                 : isLandscapeMode
                                 ? 30
                                 : 0,
                              // marginBottom: 8,
                              width: isLandscapeMode
                                 ? width * 0.54
                                 : isLandscapeSmallWebView
                                 ? '60vw'
                                 : width * 0.7,
                           },
                        }),
                     }}>
                     {/** First row showing required score to pass the course */}
                     <View
                        style={{
                           justifyContent: 'center',
                           alignItems: 'center',
                           width: '60%',
                           ...Platform.select({
                              web: {
                                 width: isLandscapeMode ? '60%' : null,
                              },
                           }),
                        }}>
                        <Text
                           style={{
                              fontSize: isLandscapeMode ? 26 : 16,
                              color: '#26E555',
                              fontFamily: FONT_FAMILY_REGULAR,
                              fontWeight: '700',
                              textAlign: 'center',
                              ...Platform.select({
                                 web: {
                                    marginBottom: 0,
                                 },
                              }),
                           }}>
                           {percentageRequirement}% Needed to Pass
                        </Text>
                     </View>

                     {/** Second row showing correct answer */}
                     <View
                        style={{
                           flexDirection: 'row',
                           justifyContent: 'space-between',
                           width: '60%',
                           marginVertical: isLandscapeMode ? 18 : 8,
                           ...Platform.select({
                              web: {
                                 width: isLandscapeMode
                                    ? '45%'
                                    : isLandscapeSmallWebView
                                    ? '45%'
                                    : '70%',
                              },
                           }),
                        }}>
                        <View
                           style={{
                              width: '80%',
                              ...Platform.select({
                                 web: {
                                    width: isLandscapeMode ? '70%' : null,
                                 },
                              }),
                           }}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 16,
                                 color: '#FFFFFF',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 fontWeight: '400',
                                 marginLeft: 0,
                                 textAlign: 'left',
                              }}>
                              Correct Answers:
                           </Text>
                        </View>

                        <View
                           style={{width: '20%', flexDirection: 'row-reverse'}}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 16,
                                 color: '#FFFFFF',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 fontWeight: '400',
                              }}>
                              {correctAnswerCount}
                           </Text>
                        </View>
                     </View>

                     {/** Third row showing Question asked */}
                     <View
                        style={{
                           flexDirection: 'row',
                           justifyContent: 'space-between',
                           width: '60%',
                           marginVertical: isLandscapeMode ? 18 : 8,
                           ...Platform.select({
                              web: {
                                 width: isLandscapeMode
                                    ? '45%'
                                    : isLandscapeSmallWebView
                                    ? '45%'
                                    : '70%',
                              },
                           }),
                        }}>
                        <View
                           style={{
                              width: '80%',
                              ...Platform.select({
                                 web: {
                                    width: isLandscapeMode ? '80%' : null,
                                 },
                              }),
                           }}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 16,
                                 color: '#FFFFFF',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 fontWeight: '400',
                                 marginLeft: 0,
                                 textAlign: 'left',
                              }}>
                              Questions Asked:
                           </Text>
                        </View>

                        <View
                           style={{width: '20%', flexDirection: 'row-reverse'}}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 16,
                                 color: '#FFFFFF',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 fontWeight: '400',
                              }}>
                              {questionAsked}
                           </Text>
                        </View>
                     </View>

                     {/** Third row showing final score */}
                     <View
                        style={{
                           flexDirection: 'row',
                           justifyContent: 'space-between',
                           width: '60%',
                           marginTop: isLandscapeMode ? 18 : 8,
                           ...Platform.select({
                              web: {
                                 width: isLandscapeMode
                                    ? '45%'
                                    : isLandscapeSmallWebView
                                    ? '45%'
                                    : '70%',
                              },
                           }),
                        }}>
                        <View
                           style={{
                              width: '70%',
                              ...Platform.select({
                                 web: {
                                    width: isLandscapeMode ? '70%' : null,
                                 },
                              }),
                           }}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 16,
                                 color: '#FFFFFF',
                                 fontFamily: FONT_FAMILY_BOLD,
                                 fontWeight: '700',
                                 marginLeft: 0,
                                 textAlign: 'left',
                              }}>
                              Final Score:
                           </Text>
                        </View>

                        <View
                           style={{
                              width: '30%',
                              flexDirection: 'row-reverse',
                              ...Platform.select({
                                 web: {
                                    width: isLandscapeMode ? '30%' : '50%',
                                 },
                              }),
                           }}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 16,
                                 color: '#FFFFFF',
                                 fontFamily: FONT_FAMILY_BOLD,
                                 fontWeight: '700',
                              }}>
                              {finalScore}%
                           </Text>
                        </View>
                     </View>
                  </View>
               </View>

               {/**
         *
         *
         * <View
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            height: isLandscapeMode ? height * 0.33 : height * 0.39,
            width: isLandscapeMode ? width * 0.54 : width * 0.45,
            marginTop: isLandscapeMode ? 24 : 8,
            justifyContent: 'center',
            paddingBottom: '3%',
          }}>
          <View
            style={{
              height: isLandscapeMode ? height * 0.33 : height * 0.39,
              width: isLandscapeMode ? width * 0.54 : width * 0.45,
              backgroundColor: '#FFFFFF',
              opacity: 0.2,
              borderRadius: isLandscapeMode ? 16 : 8,
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}></View>
          <Text
            style={{
              fontSize: isLandscapeMode ? 30 : 16,
              color: '#11A75C',
              fontFamily: FONT_FAMILY_REGULAR,
              marginTop: isLandscapeMode ? height * 0.04 : 16,
              fontWeight: '700',
            }}>
            {percentageRequirement}% Needed to Pass
          </Text>
          <View
            style={{
              flexDirection: 'row',
              width: isLandscapeMode ? width * 0.24 : width * 0.215,
              marginTop: isLandscapeMode ? height * 0.039 : 8,
            }}>
            <View
              style={{
                width: isLandscapeMode ? 314 : 170,
              }}>
              <Text
                style={{
                  fontSize: isLandscapeMode ? 30 : 16,
                  color: '#FFFFFF',
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontWeight: '500',
                  marginLeft: 0,
                }}>
                Correct Answers:
              </Text>
            </View>

            <Text
              style={{
                fontSize: isLandscapeMode ? 30 : 16,
                color: '#FFFFFF',
                fontFamily: FONT_FAMILY_REGULAR,
                fontWeight: '500',
              }}>
              {correctAnswerCount}
            </Text>
          </View>

          <View
            style={{
              flexDirection: 'row',
              width: isLandscapeMode ? width * 0.24 : width * 0.215,
              marginTop: isLandscapeMode ? height * 0.031 : 16,
            }}>
            <View
              style={{
                width: isLandscapeMode ? 314 : 170,
              }}>
              <Text
                style={{
                  fontSize: isLandscapeMode ? 30 : 16,
                  color: '#FFFFFF',
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontWeight: '500',
                  marginLeft: 0,
                }}>
                Questions Asked:
              </Text>
            </View>
            <Text
              style={{
                fontSize: isLandscapeMode ? 30 : 16,
                color: '#FFFFFF',
                fontFamily: FONT_FAMILY_REGULAR,
                fontWeight: '500',
              }}>
              {questionAsked}
            </Text>
          </View>

          <View
            style={{
              flexDirection: 'row',
              width: isLandscapeMode ? width * 0.24 : width * 0.215,
              marginTop: isLandscapeMode ? height * 0.031 : 16,
            }}>
            <View
              style={{
                width: isLandscapeMode ? 314 : 170,
              }}>
              <Text
                style={{
                  fontSize: isLandscapeMode ? 30 : 16,
                  color: '#FFFFFF',
                  fontFamily: FONT_FAMILY_BOLD,
                  fontWeight: '700',
                  marginLeft: 0,
                }}>
                Final Score:
              </Text>
            </View>
            <Text
              style={{
                fontSize: isLandscapeMode ? 30 : 16,
                color: '#FFFFFF',
                fontFamily: FONT_FAMILY_BOLD,
                fontWeight: '700',
              }}>
              {finalScore}%
            </Text>
          </View>
        </View>
         */}

               <Text
                  style={{
                     fontSize: isLandscapeMode ? 24 : 14,
                     color: '#FFFFFF',
                     fontFamily: FONT_FAMILY_BOLD,
                     fontWeight: isLandscapeMode ? '400' : '600',
                     marginTop: isLandscapeMode ? 24 : 10,
                     //opacity: 0.6,
                     ...Platform.select({
                        web: {
                           marginTop: isLandscapeSmallWebView
                              ? 12
                              : isLandscapeMode
                              ? 18
                              : 0,
                           marginBottom: isLandscapeSmallWebView
                              ? 12
                              : isLandscapeMode
                              ? 18
                              : 0,
                           //fontSize: isLandscapeMode ? 30 : 14,
                           whiteSpace: 'initial',
                           paddingHorizontal: 24,
                           textAlign: 'center',
                        },
                     }),
                  }}>
                  {buttonActionHeaderText}
               </Text>

               <TouchableOpacity
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  onPress={() => {
                     if (isApiLoading) {
                        return;
                     }
                     if (isPassed && finalScore < 100) {
                        setFinalTestReviewEnable(true);
                     } else {
                        finalTestReviwSubmitted();
                     }
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        width: isLandscapeMode
                           ? isPassed
                              ? width * 0.095
                              : width * 0.079
                           : isPassed
                           ? width * 0.113
                           : width * 0.094,
                        height: isLandscapeMode
                           ? height * 0.06
                           : height * 0.106,
                        backgroundColor: isHover
                           ? WHITE_ICON_HOVER_TINT_COLOR
                           : '#F2F5FF',
                        marginTop: isLandscapeMode ? 24 : 10,
                        borderRadius: 6,
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...Platform.select({
                           web: {
                              marginBottom: isLandscapeMode ? 24 : 10,
                              height: isLandscapeMode
                                 ? height * 0.08
                                 : isLandscapeSmallWebView
                                 ? height * 0.106
                                 : 40,
                              width: isLandscapeMode
                                 ? isPassed
                                    ? width * 0.095
                                    : width * 0.079
                                 : isLandscapeSmallWebView
                                 ? isPassed
                                    ? width * 0.09
                                    : width * 0.09
                                 : 92,
                           },
                        }),
                     }}>
                     <Text
                        style={{
                           color: '#003DA5',
                           fontFamily: FONT_FAMILY_MEDIUM,
                           fontWeight: isLandscapeMode ? '500' : '700',
                           fontSize: isLandscapeMode ? 20 : 14,
                        }}>
                        {buttonActionText}
                     </Text>
                     <Image
                        style={{
                           width: isLandscapeMode ? 20 : 13,
                           height: isLandscapeMode ? 15 : 9,
                           marginLeft: 8,
                        }}
                        source={require('../../assets/correct_begin_test.png')}
                     />
                  </View>
               </TouchableOpacity>
            </View>
         </ImageBackground>
      </View>
   );
   function finalTestReviwSubmitted() {
      try {
         isWeb && closeFullscreen();
         if (!isLandscapeMode) {
            Orientation.lockToPortrait();
         }
         if (isPassed && getMCompetedCount <= 1) {
            dispatch(setIsDashboardRefreshRequired(true));
            retrieveAppData(COURSE_ROOT_ITEM)
               .then(res => {
                  const item = JSON.parse(res);
                  const wwwCourse = item.courseNameID + '/manifest.xc';
                  removeSaveItem(wwwCourse)
                     .then(() => {
                        /* if (!isWeb) {
                                 navigation.pop(5);
                              } */
                        navigation.navigate('DashboardScreen');
                     })
                     .catch(error => {
                        logger('error::', error);
                     });
               })
               .catch(error => {
                  logger('error::', error);
               });
         } else {
            navigation.pop(4);
            navigation.navigate('courseLoading', {
               courseData: updateEnrolledCourseData,
            });
         }
      } catch (error) {
         logger('EXCEPTION', error);
         navigation.pop(4);
      }
   }
};

const styles = StyleSheet.create({
   backgroundImage: {
      flex: 1,
      resizeMode: 'contain',
      alignItems: 'center',
      // opacity:0.5
   },
});

export default ScoreBoard;
